import React, { useContext } from 'react'

import { ThemeContext } from '../../contexts'
import { TableCellProps } from '../../types'
import './style.scss'

const TableCell = ({
  sortCountries,
  isNameReversing,
  isPopReversing,
  isRegionReversing,
}: TableCellProps) => {
  const { theme } = useContext(ThemeContext)

  return (
    <tr className="cell">
      <td
        className="cell__item cell__item--hide-mobile"
        style={{ color: theme.text }}
      >
        <p>Flag</p>
      </td>

      <td className="cell__item grow" style={{ color: theme.text }}>
        <form className="cell__form">
          <label htmlFor="name">Name</label>
          <input
            type="checkbox"
            value="name"
            className="sort__input"
            onChange={sortCountries}
          />
        </form>

        {isNameReversing ? (
          <i className="fas fa-chevron-up"></i>
        ) : (
          <i className="fas fa-chevron-down"></i>
        )}
      </td>
      <td
        className="cell__item cell__item--hide-mobile"
        style={{ color: theme.text }}
      >
        Capital
      </td>

      <td className="cell__item grow" style={{ color: theme.text }}>
        <form className="cell__form">
          <label htmlFor="name">Population</label>
          <input
            type="checkbox"
            value="population"
            className="sort__input"
            onChange={sortCountries}
          />
        </form>
        {isPopReversing ? (
          <i className="fas fa-chevron-up"></i>
        ) : (
          <i className="fas fa-chevron-down"></i>
        )}
      </td>
      <td
        className="cell__item cell__item--hide-mobile"
        style={{ color: theme.text }}
      >
        Languages
      </td>
      <td className="cell__item grow" style={{ color: theme.text }}>
        <form className="cell__form">
          <label htmlFor="name">Region</label>
          <input
            type="checkbox"
            value="region"
            className="sort__input"
            onChange={sortCountries}
          />
        </form>
        {isRegionReversing ? (
          <i className="fas fa-chevron-up"></i>
        ) : (
          <i className="fas fa-chevron-down"></i>
        )}
      </td>
      <td
        className="cell__item cell__item--hide-mobile"
        style={{ color: theme.text }}
      >
        Maps
      </td>
    </tr>
  )
}

export default TableCell
